'use strict';

const SELECTOR = '.donation-panel';

export function init() {
    document.querySelectorAll(SELECTOR).forEach(element => {
        element.addEventListener('submit', event => {
            event.preventDefault();

            let amount = event.target.amount.value;
            // const ct = event.target.ct.value;

            if (!amount) {
                return alert('Please select a donation amount');
            }

            // New approach adding the amount to the end of the url path
            const baseAction = event.target.action.replace(/\/\d+$/, '');
            const url = `${baseAction}/${amount}`;

            // Optional tracking params for BlocksOffice (designation ID / source number)
            const params = new URLSearchParams();
            const {designation, sourcenumber} = event.target.dataset;
            if (designation) {
                params.set('designation', designation);
            }
            if (sourcenumber) {
                params.set('sourcenumber', sourcenumber);
            }

            const query = params.toString();
            window.location.href = query ? `${url}?${query}` : url;

            // Old approach using URL and search params
            //
            // const url = new URL(event.target.action);
            // url.searchParams.set('amount', amount);
            // url.searchParams.set('ct', ct);
            // window.location.href = url.toString();
        });
    });
}
